import { ContentViewStyle } from '@levelapp/softfabric';
export default class ToastWebViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.container = {
            padding: 15,
            maxWidth: 400,
            alignSelf: 'flex-end',
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8
        };
    }
}
